import type { PopperData } from '@presentation/components';
import { useCallback, useState } from 'react';
import { usePopper as useReactPopper } from 'react-popper';
import { useClickOutside } from '.';

export const usePopper = (params?: Partial<PopperData>) => {
  const [open, setOpen] = useState<boolean>(params?.open ?? false);
  const [triggerElement, setTriggerElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  useClickOutside(popperElement, () => {
    setOpen(false);
  });

  const popperProps = useReactPopper(triggerElement, popperElement, {
    modifiers: [
      {
        name: 'offset',
        options: { offset: [0, 10] },
      },
    ],
  });

  const show = useCallback(() => {
    setOpen(true);
  }, []);

  const close = useCallback(() => {
    setOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setOpen(!open);
  }, [open]);

  return {
    show,
    toggle,
    close,
    setTriggerElement,
    popper: {
      open,
      setPopperElement,
      popperProps,
    } as PopperData,
  };
};
